<template lang="html">
  <v-container fluid class="px-sm-10">
    <v-row>
      <v-col cols="auto" class="headline">Z-Report</v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card :loading="state.loading">
          <base-items storeModule="zreports" :filter="reportsFilter" @items="items = $event" @state="state = $event"></base-items>
          <base-items :loadOnTrigger="!selectedReport" storeModule="payments" :filter="paymentsFilter" @items="payments = $event" @state="paymentsState = $event"></base-items>

          <v-card-title>
            Points Of Sale
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                v-for="pos in pointsOfSaleOptions"
                :key="pos.id"
                cols="auto"
              >
                <v-chip
                  :color="pos.selected ? 'primary' : 'primary'"
                  :outlined="!pos.selected"
                  @click="selectedPos = pos.id"
                >
                  {{pos.name}}
                </v-chip>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-title>
            Reports
            <v-spacer/>
            <v-checkbox
              class="body-2 mt-0"
              label="Fetch all reports"
              v-model="fetchAllReports"
              hide-details
            ></v-checkbox>
          </v-card-title>

          <v-card-text>

            <v-data-table
              :headers="tableHeaders"
              :items="items"
              :items-per-page="5"
              class="zreports-table"
              must-sort
              sort-by="created_at"
              :sort-desc="true"
              @click:row="selectReport"
            >
              <template v-slot:item.point_of_sale="{ item }">
                <span>{{((item.point_of_sale || '').match(/FTP\d{3}/) || [''])[0]}}</span>
              </template>
              <template v-slot:item.id="{ item }">
                <v-checkbox readonly :input-value="item == selectedReport"></v-checkbox>
              </template>
            </v-data-table>
          </v-card-text>

          <v-card-title style="max-width: 29rem;">
            Selected report
            <v-spacer />
            <v-btn class="" @click="print" color="primary" :disabled="!selectedReport || paymentsState.loading">Print</v-btn>
          </v-card-title>

          <v-card-text>
            <div v-if="!selectedReport" class="">
              No report selected. Select one in the list above
            </div>
            <div v-else-if="paymentsState.loading" class="">
              <v-progress-circular color="primary" indeterminate></v-progress-circular>
            </div>
            <div v-else>

              <div ref="print">
                <div class="zreport-container text--disabled">
                  <x-z-report
                    type="Z"
                    :payments="payments"
                    :date="date"
                    :org-name="overview.org_name"
                    :org-number="overview.org_number"
                    :serial-number="selectedReport.serial_number"
                    :point-of-sale="selectedReport.point_of_sale"
                    :unfinished-items-count="selectedReport.unfinished_items_count"
                    :unfinished-bills-count="selectedReport.unfinished_bills_count"
                    :unfinished-amount="selectedReport.unfinished_amount"
                    :receipts-count="selectedReport.receipts_count"
                    :receipt-copies-count="selectedReport.receipt_copies_count"
                  ></x-z-report>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import XZReport from '../components/XZReport.vue'
import {BaseItems} from 'dync-baseitem'
import moment from 'moment-timezone'

export default {
  data () {
    return {
      datemenu: false,
      items: [],
      state: {},
      payments: [],
      paymentsState: {},
      selectedPos: 'all',
      selectedReport: null,
      fetchAllReports: false,
      tableHeaders: [
        {
          text: 'Selected',
          value: 'id',
          sortable: false
        },
        {
          text: 'Point of sale',
          value: 'point_of_sale'
        },
        {
          text: 'Serial number',
          value: 'serial_number'
        },
        {
          text: 'Created at',
          value: 'created_at'
        },
        {
          text: 'Total',
          value: 'total'
        },
        {
          text: 'Created by',
          value: 'created_by'
        }
      ]
    };
  },
  computed: {
    date() {
      if (this.selectedReport == null) {
        return null;
      }
      var payments = this.payments.slice(0).sort((a, b) => {
        if (a.dateCreated < b.dateCreated) {
          return 1;
        } else if (a.dateCreated > b.dateCreated) {
          return -1;
        } else {
          return 0;
        }
      });
      var reports = this.items.slice(0).sort((a, b) => {
        if (a.created_at < b.created_at) {
          return 1;
        } else if (a.created_at > b.created_at) {
          return -1;
        } else {
          return 0;
        }
      });
      var previous_report = null;
      for (let i = 0, l = reports.length; i < l; i++) {
        if (reports[i].id == this.selectedReport.id) {
          previous_report = reports[i+1];
          break;
        }
      }
      var oldest_payment = payments[payments.length-1];
      if (oldest_payment) {
        var oldest_date = moment(oldest_payment.dateCreated).format('YYYY-MM-DD HH:mm:ss');
      }
      var report_date = moment(this.selectedReport.created_at, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
      if (previous_report) {
        var previous_report_date = moment(previous_report.created_at, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
        return previous_report_date + ' - ' + report_date;
      } else if (oldest_payment) {
        return oldest_date + ' - ' + report_date;
      } else {
        return report_date;
      }
    },
    paymentsFilter () {
      if (this.selectedReport == null) {
        return {};
      }
      var result;
      if (this.selectedReport.point_of_sale) {
        result = {
          keyValue: [
            ['pointOfSale', this.selectedReport.point_of_sale],
            ['paymentLockId', this.selectedReport.serial_number]
          ]
        };
      } else {
        result = {
          keyValue: [
            ['paymentLockId', this.selectedReport.id]
          ]
        };
      }
      return result;
    },
    reportsFilter() {
      var result = {}
      if (!this.fetchAllReports) {
        result.greaterThan = [
          ['created_at', moment().subtract(1, 'months').tz('Europe/Stockholm').format('YYYY-MM-DD HH:mm:ss')]
        ];
      }
      if (this.selectedPos != 'all') {
        result.keyValue = [
          ['point_of_sale', this.selectedPos]
        ];
      }
      return result;
    },
    overview () {
      const items = this.$store.getters['overviews/items'];
      return items.length > 0 ? items[0] : {};
    },
    pointsOfSale () {
      var unique_poss = {};
      var reports = this.$store.getters['zreports/items']
      return reports.map((zreport) => zreport.point_of_sale)
      .filter((pos) => !!pos)
      .sort()
      .filter((pos) => {
        if (unique_poss.hasOwnProperty(pos)) {
          return false;
        }
        unique_poss[pos] = true;
        return true;
      })
      .map((pos) => {
        return {
          id: pos,
          name: (pos.match(/FTP\d{3}/) || [''])[0] || pos
        };
      });
    },
    pointsOfSaleOptions () {
      var options = [{id: 'all', name: 'All'}, ...this.pointsOfSale];
      options = options.map((option) => {
        option = {...option};
        option.selected = option.id == this.selectedPos;
        return option;
      });
      return options;
    }
  },
  methods: {
    selectReport(item) {
      this.selectedReport = item;
    },
    print() {
      var newWindow = window.open();
      var vapp = document.getElementById('app').cloneNode();
      var vwrap = document.getElementsByClassName('v-application--wrap')[0].cloneNode();
      vapp.appendChild(vwrap);
      vwrap.innerHTML = this.$refs.print.innerHTML
      // Copy head for styling and print container for content
      newWindow.document.write(document.head.innerHTML + '\n\n' + vapp.outerHTML);
      // Set title
      newWindow.document.title = `z-report_${(this.overview.name || '').toLowerCase().split(' ').join('_')}_${moment(this.selectedReport.created_at).format('YYYYMMDD_HHMMSS')}`;
      // Poll for page to render before starting print
      var intervalId = setInterval(() => {
        if (newWindow.document.documentElement.offsetHeight > 0) {
          clearInterval(intervalId);
          setTimeout(function () {
            newWindow.print();
            newWindow.close();
          }, 2000);
        }
      }, 100);
    }
  },
  components: {
    XZReport,
    BaseItems
  }
}
</script>

<style scoped lang="scss">
.zreports-table::v-deep td:first-of-type,
.zreports-table::v-deep th:first-of-type {
    width: 120px;
}

.zreports-table::v-deep tr {
    cursor: pointer;
}

.zreport-container {
  max-width: 27rem;
  border: 1px solid currentcolor;
  padding: 1rem;
}
</style>

<style lang="scss">
@media print {
  .zreport-container {
    max-width: 30rem;
    width: 30rem;
    border-color: transparent !important;
    margin: 0 auto !important;
    color: black !important;

    .v-divider {
      background-color: black !important;
      border-color: black !important;
    }
  }
}
</style>
